module.exports = __webpack_public_path__ + "img/top_blog_bg.01879f07.png";